import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivationEnd } from '@angular/router';
import { Ps } from "../services/ps.service";
import { PsProvider } from '../shared/PsProvider';
import { ViewportScroller } from '@angular/common';
import { PsSpecialty } from "../shared/PsSpecialty";

@Component({
    selector: 'app-ps-feature',
    templateUrl: "providerSearch.component.html",
    styles: [],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ProviderSearch implements OnInit {
    title = 'Astiva Health';
    contract_type = '0';
    specialty = 0;
    ipa = '000';
    name;
    location;
    radius_distance = 0;
    zoom = 15;
    activeProvider = 0;
    //public psProvidersView: PsProvider[];
    haveSearched = false;
    url = window.location.href;
    languageCode = 0;
    page: number = 1; // for ngx-p
    filteredSpecialties: PsSpecialty[] = [];
    disabledIPA: boolean = false;
    is4A: boolean = false;
    calendarYear: string = '2025'; // default to show providers for 2025
    connectureReturnURL4AgentTest: string = 'https://astivahealth2.staging.destinationrx.com/PC/Agent/a/aux/enrollment/callback/15?';
    connectureReturnURL4ConsumerTest: string = 'https://astivahealth1.staging.destinationrx.com/PC/2024/a/aux/enrollment/callback/15?';
    connectureReturnURL4Agent: string = 'https://astivahealth2.destinationrx.com/PC/Agent/a/aux/enrollment/callback/15?';
    connectureReturnURL4Consumer: string = 'https://astivahealth1.destinationrx.com/PC/2024/a/aux/enrollment/callback/15?';
    connectureReturnURL: string = this.connectureReturnURL4Agent; // Set default value of Return URL to Agent site on Production.
    //referringUrl: string;

    ancillarySpecialties: string[] = ['Ambulatory Surgery Center', 'Cardiac Surgery', 'Colorectal Surgery Clinic', 'Dialysis', 'Durable Medical Equipment', 'ENT/Head & Neck Surgery Clinic', 'Home Health Agency', 'Home Infusion/Specialty Pharmacy', 'Infusion Center', 'OP Mental Health', 'Physical Therapy', 'Physical Therapy/Aquatic', 'Physical Therapy/Occupational Therapy', 'Prosthetic/Orthotic', 'Radiation Therapy', 'Rehabilitation', 'Skilled Nursing Facility', 'Urgent Care'];
    hospitalSpecialties: string[] = ['Acute Inpatient', 'Inpatient Psych', 'Rehab Hospital'];
    pcpSpecialties: string[] = ['Family Medicine', 'Family Practice', 'General Practice', 'Internal Medicine', 'Interventional Cardiology', 'Preventive Medicine'];
    spcSpecialties: string[] = ['Acupuncture', 'Addiction Medicine', 'Allergy', 'Allergy & Immunology', 'Anatomic Pathology & Clinical Pathology', 'ANESTHESIOLOGY', 'Audiology', 'Bariatric Medicine', 'Bariatric Surgery', 'Cardiac Electrophysiology', 'Cardiac Surgery', 'CARDIOLOGY', 'Cardiothoracic Surgery', 'Cardiovascular Diseases', 'Cardiovascular Surgery', 'CHIROPRACTIC', 'Chiropractor', 'Clinical & Social Worker', 'Clinical Genetics', 'Clinical Neurophysiology', 'Clinical Pathology', 'Clinical Psychology', 'CLINICAL SOCIAL WORKER', 'Colon & Rectal Surgery', 'Critical Care Medicine', 'Dental Specialist', 'DERMATOLOGY', 'Dermatopathology', 'Diagnostic Radiology', 'Emergency Medicine', 'ENDOCRINOLOGY', 'Endocrinology, Diabetes & Metabolism', 'Family Medicine', 'Family Practice', 'Female Pelvic Medicine & Reconstructive Surgery', 'Foot & Ankle Surgery', 'Gastroenterology', 'General Dentistry', 'General Practice', 'GENERAL SURGERY', 'GERIATRIC MEDICINE', 'Gynecological Oncology', 'Gynecology', 'HAND SURGERY', 'Hematology', 'Hematology/Oncology', 'Hepatobiliary/Pancreatic Surgery', 'Hepatology', 'HIV Specialist', 'Hospice & Palliative Medicine', 'Hospice And Palliative Care', 'Hospitalist', 'Infectious Diseases', 'Infertility', 'Integrative Medicine', 'Internal Medicine', 'Interventional Cardiology', 'Interventional Radiology', 'Licensed Clinical Social Worker', 'Licensed Marriage & Family Therapist', 'Licensed Professional Clinical Counselor', 'MARRIAGE & FAMILY THERAPIST', 'Maternal & Fetal Medicine', 'Medical Genetics', 'Medical Oncology', 'Mental Health', 'Micrographic Dermatologic Surgery', 'Nephrology', 'NEUROLOGICAL SURGERY', 'Neurology', 'Neuromusculoskeletal Medicine', 'Neuropsychology', 'Neuroradiology', 'NEUROSURGERY', 'Nuclear Medicine', 'Nurse Anesthetist', 'Nurse Practitioner', 'Obstetrics & Gynecology', 'Occupational Medicine', 'Occupational Therapy', 'Oculoplastic Surgery', 'Oncology', 'ONCOLOGY SURGERY', 'Ophthalmic Plastic & Reconstructive Surgery', 'OPHTHALMOLOGY', 'OPTOMETRY', 'Oral & Maxillofacial Surgery', 'Oralfacial Pain', 'ORTHOPAEDIC SURGERY', 'ORTHOPEDIC SURGERY', 'OTOLARYNGOLOGY', 'PAIN MANAGEMENT', 'Pain Medicine', 'PATHOLOGY', 'Perinatology', 'Physical Medicine', 'Physical Medicine & Rehabilitation', 'Physical Therapy', 'Physician Assistant', 'PHYSICIANS ASSISTANT', 'PLASTIC & RECONSTRUCTIVE SURGERY', 'Plastic Surgery', 'Podiatry', 'Preventive Medicine', 'Psychiatry', 'Psychiatry ', 'Psychology', 'Pulmonary Diseases', 'PULMONOLOGY', 'Radiation Oncology', 'Radiology', 'REGISTERED DIETITIAN NUTRITIONIST', 'Reproductive Endocrinology', 'Retinal Specialist', 'Retinal Surgery', 'Rheumatology', 'Sleep Medicine', 'Speech Pathology', 'SPEECH THERAPY', 'Sports Medicine', 'Surgical Oncology', 'Therapeutic Radiology', 'THORACIC SURGERY', 'Transplant Hepatology', 'Urgent Care', 'Urgent Care Medicine', 'Urogynecology', 'UROLOGY', 'VASCULAR & INTERVENTIONAL RADIOLOGY', 'Vascular Medicine', 'VASCULAR SURGERY', 'Venous Medicine', 'WOUND CARE'];
    dentistSpecialties: string[] = ['Endodontics', 'General Dentistry', 'Implantologists', 'Oral & Maxillofacial Surgery', 'Oral Surgery', 'Orthodontics', 'Periodontics', 'Prosthodontics'];
    acupuncturistSpecialties: string[] = ['Acupuncture', 'Massage Therapy'];

    directoryType: string = '1';

    contractType4PCPSPCPOptions = [
        { text: 'any provider', value: '0' },
        { text: 'an Ancillary Provider(Surgery Center, Skilled Nursing Facility, etc…)', value: 'ancillary' },
        { text: 'a Hospital(Acute Care, Psych, etc...)', value: 'hospital' },
        { text: 'a Primary Care Physician', value: 'pcp' },
        { text: 'a Specialist(Cardiologist, Podiatrist, etc...)', value: 'spc' }
    ];
    contractType4DentistOptions = [
        { text: 'a dentist', value: 'dentist' }
    ];
    contractType4AcupuncturistPOptions = [
        { text: 'an acupuncturist', value: 'acupuncturist' }
    ];

    selectedOption: string = '0';

    constructor(public ps: Ps, private viewportScroller: ViewportScroller) {
        //console.log(this.url)
        if (this.url.indexOf('en-us') > -1) { this.languageCode = 1 }
        else if (this.url.indexOf('vi-vn') > -1) { this.languageCode = 2 }
        else if (this.url.indexOf('es-es') > -1) { this.languageCode = 3 }

        if (this.url.indexOf('-4a') > -1 || this.url.indexOf('-4A') > -1) {
            this.is4A = true;
            this.calendarYear = '2025';
            this.connectureReturnURL = this.connectureReturnURL4Agent;

        }

        if (this.url.indexOf('-4c') > -1 || this.url.indexOf('-4C') > -1) {
            this.is4A = true;
            this.calendarYear = '2025';
            this.connectureReturnURL = this.connectureReturnURL4Consumer;
        }

        if (this.url.indexOf('-4n') > -1 || this.url.indexOf('-4N') > -1) {
            this.calendarYear = '2025';
        }

        if (this.url.indexOf('search-dentist') > -1 || this.url.toLowerCase().indexOf('-search-dentist') > -1) {
            this.directoryType = '2';
            this.selectedOption = 'dentist';
            this.contract_type = 'dentist';
            //
            this.filteredSpecialties = [];
            this.ps.psSpecialties.forEach(s => this.copySpecialties(s, 'dentist'));
            this.specialty = 0;
        }

        if (this.url.indexOf('-search-acupuncturist') > -1 || this.url.toLowerCase().indexOf('-search-acupuncturist') > -1) {
            this.directoryType = '3';
            this.selectedOption = 'acupuncturist';
            this.contract_type = 'acupuncturist';
            //
            this.filteredSpecialties = [];
            this.ps.psSpecialties.forEach(s => this.copySpecialties(s, 'acupuncturist'));
            this.specialty = 0;
        }
    }

    search(formValues) {
        this.haveSearched = true;
        if (formValues.name == null) { formValues.name = "" } else { formValues.name = formValues.name.trim(); }
        if (formValues.location == null) { formValues.location = "" } else { formValues.location = formValues.location.trim(); }
        if (formValues.name.length == 0 && formValues.location.length == 0 && formValues.contract_type == 0 && formValues.specialty == 0 && formValues.ipa == '000') {
            ; // no changes made
        }
        else {
            //this.ps.loadPsProvidersWithParams(formValues.name, formValues.location, formValues.contract_type, formValues.specialty)
            //    .subscribe();
            //this.ps.loadPsProviderSearch(formValues.contract_type, formValues.specialty, formValues.name, formValues.location, formValues.radius_distance)
            //    .subscribe();
            if (this.disabledIPA) formValues.ipa = '000';

            //this.ps.loadPsProviderSearchWithIPA(formValues.contract_type, formValues.specialty, formValues.ipa, formValues.name, formValues.location, formValues.radius_distance, this.calendarYear)
            //    .subscribe();
            // Changed to using API that has an additional param named 'DirectoryType'
            this.ps.loadPsProviderSearchWithIPADirectoryType(formValues.contract_type, formValues.specialty, formValues.ipa, formValues.name, formValues.location, formValues.radius_distance, this.calendarYear, this.directoryType)
                .subscribe();
            this.page = 1;
            //console.log(formValues);
            //console.log(this.url)
            console.log(this.activeProvider);
            console.log(this.ps.psProviders);
        }

    }

    ngOnInit(): void {
        this.ps.loadPsContractTypes()
            .subscribe();

        this.ps.loadPsSpecialties()
            .subscribe();

        this.ps.loadPsDentalSpecialties()
            .subscribe();

        this.ps.loadPsAcupunctureSpecialties()
            .subscribe();
        //this.ps.loadPsProviders()
        //    .subscribe();

        this.ps.psSpecialties.forEach(val => this.filteredSpecialties.push(Object.assign({}, val)));

        //this.filteredSpecialties = myArray.forEach(val => myClonedArray.push(Object.assign({}, val))); this.ps.psSpecialties;
        if (this.directoryType == '2') {
            this.filteredSpecialties = [];
            this.ps.psSpecialties.forEach(s => this.copySpecialties(s, 'dentist'));
            this.specialty = 0;
        }

        if (this.directoryType == '3') {
            this.filteredSpecialties = [];
            this.ps.psSpecialties.forEach(s => this.copySpecialties(s, 'acupuncturist'));
            this.specialty = 0;
        }
    }

    //ngAfterViewInit(): void {

    //    this.ps.psSpecialties.forEach(val => this.filteredSpecialties.push(Object.assign({}, val)));
    //}

    showDetails(providerId): void {
        this.activeProvider = providerId;
        setTimeout(() => { this.viewportScroller.scrollToAnchor(providerId); }, 200);
        //console.log(this.activeProvider);
    }

    onContractTypeSelected(selectedContractTypeId): void {
        let contractTypeCode: string = this.ps.psContractTypes.find(ct => ct.id == selectedContractTypeId).contractTypeCode;

        this.filteredSpecialties = [];
        if (selectedContractTypeId != 0) this.ps.psSpecialties.forEach(s => this.copySpecialties(s, contractTypeCode));
        this.specialty = 0;

        // Consider disabling IPA checkbox
        if (selectedContractTypeId != 0) { this.disabledIPA = (contractTypeCode == 'ancillary' || contractTypeCode == 'hospital'); }
        else { this.disabledIPA = false; }
        //this.selectedAnyIPA = true;
        if (contractTypeCode == 'ancillary' || contractTypeCode == 'hospital') this.ipa = '000';
    }

    copySpecialties(specialty: PsSpecialty, contractTypeCode: string) {
        let isFound = false;
        switch (contractTypeCode) {
            case 'pcp':
                isFound = this.pcpSpecialties.includes(specialty.specialtyName);
                break;
            case 'spc':
                isFound = this.spcSpecialties.includes(specialty.specialtyName);
                break;
            case 'hospital':
                isFound = this.hospitalSpecialties.includes(specialty.specialtyName);
                break;
            case 'ancillary':
                isFound = this.ancillarySpecialties.includes(specialty.specialtyName);
                break;
            case 'dentist':
                isFound = this.dentistSpecialties.includes(specialty.specialtyName);
                break;
            case 'acupuncturist':
                isFound = this.acupuncturistSpecialties.includes(specialty.specialtyName);
                break;
        }
        if (isFound) this.filteredSpecialties.push(Object.assign({}, specialty));
    }
    //copySpecialties(specialty: PsSpecialty, contractTypeId: number) {
    //    let isFound = false;
    //    switch (this.ps.psContractTypes.find(ct => ct.id == contractTypeId).contractTypeCode) {
    //        case 'pcp':
    //            isFound = this.pcpSpecialties.includes(specialty.specialtyName);
    //            break;
    //        case 'spc':
    //            isFound = this.spcSpecialties.includes(specialty.specialtyName);
    //            break;
    //        case 'hospital':
    //            isFound = this.hospitalSpecialties.includes(specialty.specialtyName);
    //            break;
    //        case 'ancillary':
    //            isFound = this.ancillarySpecialties.includes(specialty.specialtyName);
    //            break;
    //    }
    //    if (isFound) this.filteredSpecialties.push(Object.assign({}, specialty));
    //}




}
